// extracted by mini-css-extract-plugin
module.exports = {"root":"imageUploader_root__1SLCA","text":"imageUploader_text__2ceTg"};